module.exports = __webpack_public_path__ + "static/media/wave.cdcda04e.svg";